import React, {useContext, useEffect, useState} from 'react'
import {Grid, FormControl, InputLabel, MenuItem, Select, FormHelperText} from '@material-ui/core'
import {ReservationConfigurationContext} from './../../../../context/ReservationConfiguration'
export default function WMemoField({data, onChange}) {
  const {users, getAllUsers} = useContext(ReservationConfigurationContext)

  const [filteredUsers, setFilteredUsers] = useState([])

  useEffect(() => {
    getAllUsers()
  }, [getAllUsers])

  useEffect(() => {
    if (data?.limit_user_list?.length) {
      let _filteredUsers = []
      users.users.map(u => {
        data.limit_user_list.map(l => {
          if (u.id === l) {
            _filteredUsers.push(u)
          }
          return true
        })
        return true
      })

      if (data?.limit_by_status === 'Active') {
        setFilteredUsers(_filteredUsers.filter(u => u.is_active === true))
      } else if (data?.limit_by_status === 'Inactive') {
        setFilteredUsers(_filteredUsers.filter(u => u.is_active === false))
      } else setFilteredUsers(_filteredUsers)
    } else if (data?.limit_by_status === 'Active') {
      setFilteredUsers(users.users.filter(u => u.is_active === true))
    } else if (data?.limit_by_status === 'Inactive') {
      setFilteredUsers(users.users.filter(u => u.is_active === false))
    } else {
      setFilteredUsers(users.users)
    }
  }, [data, users])
  return (
    <Grid item xs={6}>
      <FormControl
        fullWidth
        variant="outlined"
        className="ap-textfield"
        style={{width: 320}}
        required={false}
      >
        <InputLabel id="demo-mutiple-name-label">{data.name}</InputLabel>
        <Select
          labelId="demo-mutiple-name-label"
          id="demo-simple-select"
          label={data.name}
          value={data.value}
          onChange={(e, i) => {
            onChange(e, 'value', data, i)
            //onChange(e, 'value_name', data)
          }}
          InputLabelProps={{
            shrink: false,
          }}
        >
          {filteredUsers.map(o => {
            return <MenuItem value={o.id}>{`${o.first_name} ${o.last_name}`}</MenuItem>
          })}
        </Select>
        <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
      </FormControl>
    </Grid>
  )
}
